import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  align-items: stretch;
  padding: 12px;
  flex: 1;
`;

export const TournamentsContainer = styled.div`
  flex: 7;

  position: relative;

  h2 {
    margin-left: 90px;
    margin-top: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    font-size: 1.75rem;
  }

  @media (max-width: 400px) {
    h2 {
      margin-left: 35px;
      font-size: 1.5rem;
    }
  }
`;

export const Tournament = styled.div`
  padding: 0 15px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  overflow-y: scroll;
  max-height: 550px;

  @media (max-width: 1600px) {
    max-height: 375px;
  }

  @media (max-width: 1024px) {
    max-height: 250px;
  }

  @media (max-width: 820px) {
    max-height: max-content;
  }

  @media (max-width: 750px) {
    padding: 0;
  }
`;

export const Description = styled.aside`
  flex: 7;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  img {
    width: 350px;
  }

  strong {
    font-size: 3rem;
  }

  p {
    font-size: 1.5rem;
    line-height: 6px;
  }

  @media (max-width: 1600px) {
    img {
      width: 270px;
    }
    strong {
      font-size: 2.75rem;
    }
  }

  @media (max-width: 1024px) {
    img {
      width: 150px;
    }
    strong {
      font-size: 2.5rem;
    }

    p {
      font-size: 1.25rem;
    }
  }

  @media (max-width: 820px) {
    display: none;
  }
`;

export const InstructionsButton = styled.button`
  position: absolute;
  background: transparent;
  display: none;

  top: 25px;
  right: 60px;

  transition: filter 0.2s;

  svg {
    width: 35px;
    height: 35px;

    path {
      stroke: #7f4788;
    }
  }

  &:hover {
    filter: brightness(1.2);
  }

  @media (max-width: 820px) {
    display: flex;
  }

  @media (max-width: 540px) {
    right: 35px;
  }

  @media (max-width: 400px) {
    right: 20px;

    svg {
      width: 30px;
      height: 30px;

      path {
        stroke: #7f4788;
      }
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  strong {
    font-size: 2.5rem;
  }

  div {
    p {
      font-size: 1.5rem;
      line-height: 22px;
    }
  }

  img {
    width: 250px;
    height: 250px;
  }

  @media (max-width: 540px) {
    img {
      width: 200px;
      height: 200px;
    }
  }

  @media (max-width: 400px) {
    strong {
      font-size: 2rem;
    }

    div {
      p {
        font-size: 1.25rem;
      }
    }
  }
`;
